import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { useSite } from "@/contexts/SiteContent";
import { Icon } from "@/components/Icon";
import PhotoFrame from "@/components/PhotoFrame";
import RichText from "@/components/RichText";

export default function ProductsHubPage() {
  const { content } = useSite();
  const p = content?.products_page || {};
  const hero = p.hero || {};
  const items = p.items || [];

  return (
    <div>
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-16 pb-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <motion.div initial={{opacity:0, y:14}} animate={{opacity:1, y:0}} transition={{duration:0.5}}>
            <span className="eyebrow-bar"><span className="overline">{hero.eyebrow}</span></span>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mt-4 max-w-3xl text-navy">{hero.title}</h1>
            <RichText html={hero.subtitle} variant="subtitle" className="mt-6 max-w-3xl"/>
          </motion.div>
        </div>
        {hero.image_url && <div className="lg:col-span-5"><PhotoFrame src={hero.image_url} ratio="4/3"/></div>}
      </section>

      {hero.description && (
        <section className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 pb-12">
          <RichText html={hero.description} variant="body" testid="products-description"/>
        </section>
      )}

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it, idx) => (
            <motion.div key={it.slug} initial={{opacity:0, y:16}} whileInView={{opacity:1, y:0}} viewport={{once:true}} transition={{duration:0.45, delay: idx*0.05}}>
              <Link to={`/p/${it.slug}`} data-testid={`hub-product-${it.slug}`} className="card-flat p-7 group flex flex-col h-full">
                <div className="h-12 w-12 grid place-items-center rounded-2xl bg-saffron text-white shadow-[0_10px_22px_-10px_rgba(242,117,15,0.6)]">
                  <Icon name={it.icon} className="h-5 w-5" strokeWidth={1.8}/>
                </div>
                <h3 className="font-display text-2xl font-bold mt-5 text-navy">{it.title}</h3>
                <p className="text-sm text-ink-muted mt-2 leading-relaxed">{it.blurb}</p>
                <div className="mt-auto pt-6 flex items-center justify-between">
                  {it.rate && (
                    <div>
                      <div className="text-[10px] uppercase tracking-[0.2em] text-ink-muted">Starting at</div>
                      <div className="font-display font-bold text-lg text-navy">{it.rate}</div>
                    </div>
                  )}
                  <ArrowRight className="h-5 w-5 text-saffron group-hover:translate-x-1 transition-transform"/>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
